import React from "react";
import { Sidebar } from "primereact/sidebar";
import AvatarC from "../../avatar";
import ButtonC from "../../button";
import styles from "./index.module.scss";
import InvestorDetailsTabs from "./investor-details-tabs";
import { useAccountCheckoutDetails } from "../../../../hooks/react-query/investor-dashboard/useAccountCheckoutDetails";
import { dateMonthFormatForAccountDetails } from "../../../../utils/utils";

export default function InvestorDetailsSidebar({
  visibleInvDetail,
  setVisibleInvDetail,
  setVisibleNotes,
  position,
  setVisibleCallRecords,
  accountId,
  propertyId,
  checkoutId
}: any) {
  const { data: accountCheckoutDetails } = useAccountCheckoutDetails({
    accountId
  });
  return (
    <Sidebar
      visible={visibleInvDetail}
      position={position || "right"}
      onHide={() => setVisibleInvDetail(false)}
      className={styles.sidebarInvDetail}
      maskClassName={styles.sidebarInvDetailMask}
    >
      <div className={styles.header}>
        <div className={styles.avatarSection}>
          <AvatarC
            label={
              accountCheckoutDetails?.investorname?.split(" ")?.[0][0] +
                accountCheckoutDetails?.investorname?.split(" ")?.[1][0] ||
              accountCheckoutDetails?.accountname?.split(" ")?.[0][0] +
                accountCheckoutDetails?.accountname?.split(" ")?.[1][0]
            }
            size="large"
            shape="circle"
            className={styles.avatar}
          />
          <div>
            <div className={styles.name}>
              {accountCheckoutDetails?.investorname ||
                accountCheckoutDetails?.accountname ||
                "N/A"}
            </div>
            <div className={styles.role}>Investor</div>
          </div>
        </div>
        <img
          src="/images/close.svg"
          alt="close"
          className={styles.closeIcon}
          onClick={() => setVisibleInvDetail(false)}
        />
      </div>
      <div className={styles.companySection}>
        <div className={styles.companyName}>
          {accountCheckoutDetails?.accountname || "N/A"}
        </div>
        <div className={styles.div2}>
          <div className={styles.statValue}>
            {accountCheckoutDetails?.totalPurchased || 0}
          </div>
          <div className={styles.statLabel}>Total Purchased</div>
        </div>
        <div className={styles.div3}>
          <div className={styles.statValue}>
            {accountCheckoutDetails?.totalSold || 0}
          </div>
          <div className={styles.statLabel}>Total Sold</div>
        </div>
        <div className={styles.div4}>
          <div className={styles.statLabel}>Last Purchased</div>
          <div className={styles.statValue}>
            {accountCheckoutDetails?.lastPurchased
              ? dateMonthFormatForAccountDetails(
                  accountCheckoutDetails?.lastPurchased
                )
              : "N/A"}
          </div>
        </div>
        <div className={styles.div4}>
          <div className={styles.statLabel}>Last Listed</div>
          <div className={styles.statValue}>
            {accountCheckoutDetails?.lastListed
              ? dateMonthFormatForAccountDetails(
                  accountCheckoutDetails?.lastListed
                )
              : "N/A"}
          </div>
        </div>
        <div className={styles.div5}>
          <div className={styles.statValue}>
            {accountCheckoutDetails?.totalFlips || 0}
          </div>
          <div className={styles.statLabel}>No of Flips</div>
        </div>
        <div className={styles.div6}>
          <div className={styles.statValue}>
            {accountCheckoutDetails?.totalListed || 0}
          </div>
          <div className={styles.statLabel}>Total Listed</div>
        </div>
      </div>
      <div className={styles.actionButtons}>
        <ButtonC
          label="Add Notes"
          className={styles.addNotesBtn}
          onClick={() => setVisibleNotes(true)}
        />
        <ButtonC
          label="Record Call"
          className={styles.recordCallBtn}
          onClick={() => setVisibleCallRecords(true)}
        />
      </div>
      <InvestorDetailsTabs
        accountId={accountId}
        propertyId={propertyId}
        checkoutId={checkoutId}
      />
    </Sidebar>
  );
}
